import axiosInstance from "@/common/axiosInstance";
import apiCall from "./apiCall";

export type InspectionResult = {
    id: string,
    reportName: string,
    vesselName: string,
    imoNumber: string,
    reportType: string,
    fileId: string,
    status: number,
    created: string, // ISO date
    createdBy: string,
    modified: string, // ISO date
    modifiedBy: string | null,
};

export const getListInspectionResults = async (pageNumber: number, pageSize: number) => {
    const URL = `/UploadInspectionResult/GetListUploadInspectionResults?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return apiCall('get', URL);
};

export const postUploadInspectionResult = async (data: FormData) => {
    const URL = '/UploadInspectionResult/Create';
    try {
        const response = await axiosInstance.post<any>(URL, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        return response.data;
    } catch (err: any) {
        const obj = {
            status: err?.response?.status,
            message: err?.response?.data?.message
        }
        return obj;
    }
};
